import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { catchError, finalize } from 'rxjs/operators';
import { Observable, of as observableOf, merge, BehaviorSubject, of } from 'rxjs';
import { RetrieveService } from '../api/services/retrieve.service';
import { AudioMatchJobContents } from '../api/models/audio-match-job-contents';
import { SearchParams } from './audiomatchjobcontents-list.component';

/**
 * Data source for the  AudiomatchrunsList view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
export class AudiomatchjobContentsListDataSource implements DataSource<AudioMatchJobContents> {

  private audiomatchJobContentsSubject = new BehaviorSubject<AudioMatchJobContents[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private audiomatchJobContentsCount = new BehaviorSubject(0);

  public loading$ = this.loadingSubject.asObservable();
  public count$ = this.audiomatchJobContentsCount.asObservable();

  constructor(private retrieveService: RetrieveService) {
  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(collectionViewer: CollectionViewer): Observable<AudioMatchJobContents[]> {
    return this.audiomatchJobContentsSubject.asObservable();
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect(collectionViewer: CollectionViewer): void {
    this.audiomatchJobContentsSubject.complete();
    this.loadingSubject.complete();
  }

  loadAudiomatchJobContents(params: SearchParams) {

    this.loadingSubject.next(true);

    /* Retrieve audiomatch runs */
    this.retrieveService.getAudiomatchJobContentsList(params).pipe(
      catchError(() => {
        // console.error('getContentsList ERROR');
        return of([]);
      }),
      finalize(() => {
        // console.log('getContentsList OK');
        this.loadingSubject.next(false);
      })
    ).subscribe(contents => {
      // console.log(contents);
      this.audiomatchJobContentsSubject.next(contents);
    });

    /* Count audiomatch runs */
    this.retrieveService.countAudiomatchJobContents(params).pipe(
      catchError(() => {
        return of([]);
      }),
      finalize(() => {
        this.loadingSubject.next(false);
      })
    ).subscribe(count => {
      this.audiomatchJobContentsCount.next(count as number);
    });
  }
}

